import styled from '@emotion/styled';
import { NewProductCardLoader } from '~/shared/components/NewProductCard';

const SkeletonLoader = styled.div(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(1, 1fr)',
    gap: theme.space[3],
}));

const generateIndex = () => Math.random().toString(36).substring(7);

export const ProductListSkeleton = () => {
    return (
        <SkeletonLoader>
            {[...Array(1)].map(() => (
                <NewProductCardLoader isFavorite key={generateIndex()} preserveAspectRatio="none" />
            ))}
        </SkeletonLoader>
    );
};
